export default "__VITE_ASSET__1ea1b396__"